import { render, staticRenderFns } from "./ProductsItem.vue?vue&type=template&id=07f8610a&scoped=true&"
import script from "./ProductsItem.vue?vue&type=script&lang=ts&"
export * from "./ProductsItem.vue?vue&type=script&lang=ts&"
import style0 from "./ProductsItem.vue?vue&type=style&index=0&id=07f8610a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07f8610a",
  null
  
)

export default component.exports